import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logo_bg2",
  "use": "icon-logo_bg2-usage",
  "viewBox": "0 0 619 166",
  "content": "<symbol viewBox=\"0 0 619 166\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-logo_bg2\">\r\n<path d=\"M508.396 67.0181C597.97 22.3538 618.483 -17.7967 618.483 -24H0V164.76C45.3202 168.304 148.757 164.228 199.941 119.564C263.922 63.7334 396.429 122.849 508.396 67.0181Z\" fill=\"#1CA59D\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol